import { useContext } from 'react';
import { LocationsContext } from '.';

export const useLocations = () => {
	return useContext(LocationsContext);
};
